(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bella-christmas-giveaway"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    const panel = document.getElementById('bwg-entry');
    if (!panel) return;
    if (panel.querySelector('[data-bwg-success],[data-bwg-error]') || ['#bwg-entry','#bwg-draw-form','#bwg-newsletter-form','#bwg-terms'].includes(location.hash)) panel.open = true;
    document.querySelectorAll('[data-bwg-open]').forEach(link => {
      if (link.dataset.bwgBound) return;
      link.dataset.bwgBound = 'true';
      link.addEventListener('click', event => {
        event.preventDefault(); panel.open = true;
        panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
        panel.querySelector('input[type=email]')?.focus({preventScroll:true});
      });
    });
    document.querySelectorAll('a[href="#bwg-terms"]').forEach(link => link.addEventListener('click', () => { document.getElementById('bwg-terms').open = true; }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup); else setup();
  document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bella-media-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function enableMouseDrag(track, go) {
    let drag = null;
    let suppressClick = false;
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || track.classList.contains('is-zoomed') || event.target.closest('video,iframe,model-viewer')) return;
      drag = { x: event.clientX, scroll: track.scrollLeft, moved: false, id: event.pointerId };
    });
    track.addEventListener('pointermove', event => {
      if (!drag) return;
      const delta = event.clientX - drag.x;
      if (!drag.moved && Math.abs(delta) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      track.scrollLeft = drag.scroll - delta;
    });
    const finish = event => {
      if (!drag) return;
      const moved = drag.moved;
      const id = drag.id;
      drag = null;
      if (track.hasPointerCapture(id)) track.releasePointerCapture(id);
      track.classList.remove('is-dragging');
      if (moved) {
        suppressClick = true;
        go(Math.round(track.scrollLeft / Math.max(1,track.clientWidth)));
        setTimeout(() => { suppressClick = false; }, 0);
      }
    };
    track.addEventListener('pointerup', finish);
    track.addEventListener('pointercancel', finish);
    track.addEventListener('pointerleave', event => { if (drag && !drag.moved) drag = null; });
    track.addEventListener('click', event => {
      if (suppressClick) { event.preventDefault(); event.stopPropagation(); }
    }, true);
    track.addEventListener('dragstart', event => event.preventDefault());
  }
  class BellaCardGallery extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.bella-card-track');
      this.buttons = [...this.querySelectorAll('[data-photo]')];
      this.index = 0;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.buttons.forEach(button => button.addEventListener('click', () => this.go(Number(button.dataset.photo)), options));
      let frame = 0;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => this.update());
      }, {...options,passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      enableMouseDrag(this.track, index => this.go(index));
      this.resize = new ResizeObserver(() => this.go(this.index, false));
      this.resize.observe(this.track);
    }
    go(index, smooth = true) {
      const total = this.track.children.length;
      this.index = Math.max(0,Math.min(total - 1,index));
      this.track.scrollTo({left:this.index * this.track.clientWidth,behavior:smooth && !reduced() ? 'smooth' : 'instant'});
      this.buttons.forEach((button,i) => i === this.index ? button.setAttribute('aria-current','true') : button.removeAttribute('aria-current'));
    }
    update() {
      this.index = Math.round(this.track.scrollLeft / Math.max(1,this.track.clientWidth));
      this.buttons.forEach((button,i) => i === this.index ? button.setAttribute('aria-current','true') : button.removeAttribute('aria-current'));
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  }
  class BellaLightbox extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.bella-lightbox-track');
      this.slides = [...this.querySelectorAll('.bella-lightbox-slide')];
      this.dialog = this.closest('sht-dialog');
      this.current = this.querySelector('[data-gallery-current]');
      this.previous = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.zoomButton = this.querySelector('[data-gallery-zoom]');
      this.index = 0;
      this.previous.addEventListener('click', () => this.go(this.index - 1));
      this.next.addEventListener('click', () => this.go(this.index + 1));
      this.zoomButton.addEventListener('click', () => this.toggleZoom());
      this.track.addEventListener('dblclick', event => { if (event.target.tagName === 'IMG') this.toggleZoom(); });
      this.track.addEventListener('keydown', event => {
        if (this.zoomed || event.target.closest('video,iframe,model-viewer')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.track.addEventListener('scroll', () => {
        if (this.zoomed) return;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const index = Math.round(this.track.scrollLeft / Math.max(1,this.track.clientWidth));
          if (index !== this.index) { this.index = index; this.update(); this.pauseMedia(); }
        });
      }, {passive:true});
      enableMouseDrag(this.track, index => this.go(index));
      this.onOpening = event => {
        this.resetZoom();
        const id = event.detail?.opener?.dataset.dialogMediaId;
        const index = this.slides.findIndex(slide => slide.dataset.mediaId === id);
        requestAnimationFrame(() => this.go(index < 0 ? 0 : index, false));
      };
      this.onClosing = () => { this.resetZoom(); this.pauseMedia(); };
      this.dialog.addEventListener('opening',this.onOpening);
      this.dialog.addEventListener('closing',this.onClosing);
      this.resize = new ResizeObserver(() => { if (!this.zoomed) this.go(this.index, false); });
      this.resize.observe(this.track);
      this.update();
    }
    go(index,smooth = true) {
      this.resetZoom();
      this.index = Math.max(0,Math.min(this.slides.length - 1,index));
      this.track.scrollTo({left:this.index * this.track.clientWidth,behavior:smooth && !reduced() ? 'smooth' : 'instant'});
      this.update(); this.pauseMedia();
    }
    update() {
      this.current.textContent = this.index + 1;
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.slides.length - 1;
      this.zoomButton.hidden = !this.slides[this.index]?.querySelector('img');
      const image = this.slides[this.index]?.querySelector('img');
      if (image) image.loading = 'eager';
    }
    pauseMedia() {
      this.slides.forEach((slide,index) => {
        if (index === this.index && !this.dialog.hidden) return;
        slide.querySelectorAll('video').forEach(video => video.pause());
        slide.querySelectorAll('iframe').forEach(frame => {
          const src = frame.getAttribute('src') || '';
          if (src.includes('youtube')) frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}),'https://www.youtube.com');
          if (src.includes('vimeo')) frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}),'https://player.vimeo.com');
        });
      });
    }
    toggleZoom() {
      if (!this.slides[this.index]?.querySelector('img')) return;
      if (this.zoomed) return this.resetZoom();
      this.zoomed = true;
      this.track.classList.add('is-zoomed');
      this.slides[this.index].classList.add('is-zoomed');
      this.zoomButton.setAttribute('aria-pressed','true');
    }
    resetZoom() {
      this.zoomed = false;
      this.track.classList.remove('is-zoomed');
      this.slides.forEach(slide => { slide.classList.remove('is-zoomed'); slide.scrollLeft = 0; slide.scrollTop = 0; });
      this.zoomButton.setAttribute('aria-pressed','false');
    }
    disconnectedCallback() {
      this.resize?.disconnect();
      this.dialog?.removeEventListener('opening',this.onOpening);
      this.dialog?.removeEventListener('closing',this.onClosing);
    }
  }
  if (!customElements.get('bella-card-gallery')) customElements.define('bella-card-gallery',BellaCardGallery);
  if (!customElements.get('bella-lightbox')) customElements.define('bella-lightbox',BellaLightbox);
})();
  } catch(e) { console.error(e); }
})();

})();
